import {
  type LngLat,
  FullscreenPanel,
  FullscreenPanelBody,
  Lead,
  SearchIcon,
  Slot,
  Spinner,
  Text,
  Trail,
  Typography,
} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {type ReactElement, useState} from 'react'

import {type Props as AddressModalProps, AddressModal} from '../AddressModal/AddressModal'
import * as classes from './AddressSlot.classes'

export type Props = {
  isPending?: boolean
  coordinates: LngLat
  onCityChange: AddressModalProps['onChange']
  addressPin?: AddressModalProps['addressPin']
  onMapButtonClick?: VoidFunction
}
type State = {
  opened: boolean
}

const overlayProps = {
  className: classes.overlay,
}

export function AddressSlot(props: Props): ReactElement {
  const i18n = useI18n()
  const {coordinates, isPending, addressPin, onMapButtonClick, onCityChange} = props

  const [state, setState] = useState<State>({opened: false})
  const openHandler = () => {
    setState({opened: true})
  }
  const closeHandler = () => {
    setState({opened: false})
  }
  const mapButtonClickHandler = onMapButtonClick
    ? () => {
        onMapButtonClick()
        closeHandler()
      }
    : undefined

  return (
    <>
      <Slot
        className={classes.slot}
        mb="s"
        ml="s"
        mr="s"
        onClick={isPending ? undefined : openHandler}
        py="xs"
        size="m"
      >
        <Lead>
          <SearchIcon />
        </Lead>
        <Text>
          {addressPin ? (
            <>
              <Typography variant="body2">{addressPin.title}</Typography>
              {addressPin.subtitle && (
                <Typography className={classes.subtitle} color="minor" variant="caption1">
                  {addressPin.subtitle}
                </Typography>
              )}
            </>
          ) : (
            <Typography color="minor" variant="body2">
              {i18n('bdui.pickup_points.search', 'Поиск')}
            </Typography>
          )}
        </Text>
        <Trail mr="m">{isPending && <Spinner />}</Trail>
      </Slot>
      <FullscreenPanel anchor="bottom" backdrop={false} color="minor" opened={state.opened} overlay={overlayProps}>
        <FullscreenPanelBody>
          <AddressModal
            addressPin={addressPin}
            coordinates={coordinates}
            onChange={city => {
              onCityChange(city)
              closeHandler()
            }}
            onClose={closeHandler}
            onMapButtonClick={mapButtonClickHandler}
          />
        </FullscreenPanelBody>
      </FullscreenPanel>
    </>
  )
}
